import script from "./WCProductCardModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCProductCardModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCProductCardModern.vue?vue&type=style&index=0&id=cbcd7866&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbcd7866"]])

export default __exports__